import { Maybe } from 'maybe-not';
import { IDict } from '../types/utility';
import { sendMessage } from 'q2-tecton-common/lib/utility/message-bus';

export interface INavigateOptions {
    featureName?: string;
    moduleName?: string;
    urlParams?: any[];
    queryParams?: IDict<any>;
}

export default function navigateTo(platformCapabilities: Set<string>, moduleId: string) {
    if (!platformCapabilities.has('navigateTo')) {
        return;
    }

    function helper(featureName: string): void;
    function helper(options: INavigateOptions): void;
    function helper(featureName: string, moduleName: string): void;
    function helper(featureName: string, urlParams: any[]): void;
    function helper(featureName: string, queryParams: IDict<any>): void;
    function helper(featureName: string, urlParams: any[], queryParams: IDict<any>): void;
    function helper(featureName: string, moduleName: string, urlParams: any[]): void;
    function helper(featureName: string, moduleName: string, queryParams: IDict<any>): void;
    function helper(
        featureName: string,
        moduleName: string,
        urlParams: any[],
        queryParams: IDict<any>
    ): void;
    function helper(
        arg1: string | INavigateOptions,
        arg2?: string | any[] | IDict<any>,
        arg3?: any[] | IDict<any>,
        arg4?: IDict<any>
    ): void {
        let moduleName;
        let urlParams;
        let queryParams;
        let featureName;

        if (arguments.length === 1 && typeof arg1 !== 'string') {
            ({ featureName, moduleName, queryParams, urlParams } = arg1 as INavigateOptions);

            // depricated delete at 2.0 This enables featureName to be relative with ONLY a tecton-sdk upgrade
            featureName = featureName || moduleId.split('.').slice(-2, -1)[0];
        } else {
            featureName = arg1;
        }

        if (typeof arg2 === 'string') {
            moduleName = arg2;
        } else if (Array.isArray(arg2)) {
            urlParams = arg2;
        } else if (arg2) {
            queryParams = arg2;
        }

        if (Array.isArray(arg3)) {
            urlParams = arg3;
        } else if (arg3) {
            queryParams = arg3;
        }

        if (arg4) {
            queryParams = arg4;
        }

        sendMessage(
            `navigateTo`,
            Maybe.just({ featureName, moduleName, urlParams, queryParams }).map(JSON.stringify)
        );
    }

    return helper;
}
